/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * DRAW — questionCount questions drawn from the category at every attempt. WHOLE_CATEGORY — every question of the category. CHOSEN_QUESTIONS — the questions listed, always the same ones.
 * @export
 * @enum {string}
 */

export const TestPartKindDto = {
    Draw: 'DRAW',
    WholeCategory: 'WHOLE_CATEGORY',
    ChosenQuestions: 'CHOSEN_QUESTIONS'
} as const;

export type TestPartKindDto = typeof TestPartKindDto[keyof typeof TestPartKindDto];



